export const resetPassword = async (signUpInfo) =>{
    try{
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
        const response = await fetch(`${API_BASE_URL}/api/forgot-password`, {
            method:'POST',
            headers:{
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body:JSON.stringify({ email:signUpInfo.email}),
        });
        const result = await response.json();
        if(result.message === 'Password reset email sent'){
            return ('success')
        }
        if(result.message === 'User not found'){
            return('invalid credentials')
        }
        if(result.message === 'Error sending email'){
            return('server error')
        }
    }catch(err){
        return('server error') 
    }
}